import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
    isFleetsLoading: false,
    isFleetTypesLoading: false,
    isFleetCategoriesLoading: false,
    isFleetStatusesLoading: false,
    error: null,
    fleets: null,
    fleet_types: null,
    fleet_categories: null,
    fleet_statuses: null,
};

const slice = createSlice({
    name: 'fleet',
    initialState,
    reducers: {
        // START LOADING
        startFleetsLoading(state) {
            state.isFleetsLoading = true;
        },
        startFleetTypesLoading(state) {
            state.isFleetTypesLoading = true;
        },
        startFleetCategoriesLoading(state) {
            state.isFleetCategoriesLoading = true;
        },
        startFleetStatusesLoading(state) {
            state.isFleetStatusesLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isFleetsLoading = false;
            state.isFleetTypesLoading = false;
            state.isFleetCategoriesLoading = false;
            state.isFleetStatusesLoading = false;
            state.error = action.payload;
        },
        // GET FLEET
        setFleets(state, action) {
            state.isFleetsLoading = false;
            state.fleets = action.payload;
        },
        // GET FLEET TYPES
        setFleetTypes(state, action) {
            state.isFleetTypesLoading = false;
            state.fleet_types = action.payload;
        },
        // GET FLEET CATEGORIES
        setFleetCategories(state, action) {
            state.isFleetCategoriesLoading = false;
            state.fleet_categories = action.payload;
        },
        // GET FLEET STATUSES
        setFleetStatuses(state, action) {
            state.isFleetStatusesLoading = false;
            state.fleet_statuses = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startFleetsLoading,
    startFleetTypesLoading,
    startFleetCategoriesLoading,
    startFleetStatusesLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getFleets(params = {}) {
    return async () => {
        dispatch(slice.actions.startFleetsLoading());
        try {
            await axios.get(`/admin/fleet/fleets`, {
                params: params
            }).then((response) => {
                const { status, data } = response
                if (status == 200) {
                    dispatch(slice.actions.setFleets(data));
                }
            });
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAvailableFleets(params = {}) {
    return async () => {
        dispatch(slice.actions.startFleetsLoading());
        try {
            const response = await axios.get(`/admin/fleet/dropdown/available_fleets`, {
                params: params
            });
            dispatch(slice.actions.setFleets(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFleetTypes() {
    return async () => {
        dispatch(slice.actions.startFleetTypesLoading());
        try {
            const response = await axios.get(`/admin/fleet/fleet_types`);
            dispatch(slice.actions.setFleetTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getFleetCategories() {
    return async () => {
        dispatch(slice.actions.startFleetCategoriesLoading());
        try {
            const response = await axios.get(`/admin/fleet/fleet_categories`);
            dispatch(slice.actions.setFleetCategories(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFleetStatus() {
    return async () => {
        dispatch(slice.actions.startFleetStatusesLoading());
        try {
            const response = await axios.get(`/admin/fleet/fleet_statuses`);
            dispatch(slice.actions.setFleetStatuses(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
